import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
import { productsData, lookData, pickupData, lineupData, featureData, storiesData } from './data.js';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KTab, KScrollspy, KAccordion, AnchorTo } from './common/k-tools/k-tools.js';
import productColorSwitch from './common/colorChips.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import videoPlayer from './common/videoPlayer.js';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation.js';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);

const bannerSwiperInit = () => {
  const bannerSwiper = new Swiper('.hero__slider .swiper', {
    speed: 800,
    loop: false,
    autoplay: {
      delay: 6000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
  });
};

const productSwiperList = [];

const productSwiperInit = () => {
  const breakpoint = 1000;

  const init = () => {
    const isMobile = window.innerWidth < breakpoint;

    document.querySelectorAll('.look__products .product-list').forEach(productList => {
      const row = productList.querySelector('.row');
      const grids = row?.querySelectorAll('.grid');

      if (!row || !grids?.length) return;

      // =====================
      // Mobile
      // =====================
      if (isMobile) {
        // 已經初始化過就跳過
        if (productList.swiper) return;

        productList.classList.add('swiper');
        row.classList.add('swiper-wrapper');

        grids.forEach(grid => {
          grid.classList.add('swiper-slide');
        });

        const swiper = new Swiper(productList, {
          slidesPerView: 2.2,
          spaceBetween: 12,
          speed: 500,
          watchOverflow: true,

          observer: true,
          observeParents: true,
          observeSlideChildren: true,
        });

        productSwiperList.push(swiper);
      }

      // =====================
      // Desktop
      // =====================
      else {
        if (productList.swiper) {
          productList.swiper.destroy(true, true);
        }

        productList.classList.remove('swiper');
        row.classList.remove('swiper-wrapper');

        grids.forEach(grid => {
          grid.classList.remove('swiper-slide');
          grid.removeAttribute('style');
        });

        row.removeAttribute('style');
        productList.removeAttribute('style');
      }
    });
  };

  // 初始執行
  init();

  // resize
  let resizeTimer;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(() => {
      init();
    }, 150);
  });
};

const fixedBarHandler = () => {
  const anchorBar = $('.anchor-block.fixed');
  const startSection = $('section.concept');
  const endSection = $('section.special-report');
  const tabBar = $('.tab__navbar.fixed');
  const tabContent = $('.tab__content');
  const storeSection = $('section.store');
  const scrollHandler = () => {
    const scrollTop = $(window).scrollTop();
    // 錨點選單
    if (
      scrollTop >= Math.round(startSection.offset().top) &&
      scrollTop < Math.round(endSection.offset().top) - anchorBar.innerHeight() - 100
    ) {
      anchorBar.addClass('show');
    } else {
      anchorBar.removeClass('show');
    }

    // 頁籤選單
    if (
      scrollTop >= Math.round(tabContent.offset().top) - tabBar.innerHeight() &&
      scrollTop < Math.round(storeSection.offset().top) - tabBar.innerHeight()
    ) {
      tabBar.addClass('show');
    } else {
      tabBar.removeClass('show');
    }
  };
  $(window).on('scroll', scrollHandler);
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });
  const scrollspy = new KScrollspy('[k-scrollspy]');
  const accordion = new KAccordion('[k-accordion]', {
    onlyOneOpen: false,
    firstOpen: false,
    onOpenAnchor: false,
  });
  const tab = new KTab('[k-tab]', {
    history: true,
    onChange: tab => {
      scrollTrigger.reset(tab.activePanelEl, '[k-st]');
      gsapAnimationUpdate();
    },
  });

  const customAnchor = e => {
    const $this = $(e.currentTarget);
    const anchorTarget = $this.attr('data-anchor');
    const [controlTab, controlPanel] = anchorTarget.split('-');
    const tabEl = document.querySelector(`.nav-tabs__link[k-tab-ctrl="${controlTab}"][k-tab-target="${controlPanel}"]`);
    AnchorTo('.lineup');
    tab.activateTab(tabEl);
  };

  $('.imgAnchor__itemLink').on('click', customAnchor);

  bannerSwiperInit();
  // 商品 Swiper
  productSwiperInit();
  videoPlayer();
  fixedBarHandler();
  productColorSwitch();
  gsapAnimation();
};

// Vue
createApp({
  setup() {
    const productsDataRef = ref(productsData);
    const lookDataRef = ref(lookData);
    const pickupDataRef = ref(pickupData);
    const lineupDataRef = ref(lineupData);
    const featureDataRef = ref(featureData);
    const storiesDataRef = ref(storiesData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      productsDataRef,
      lookDataRef,
      pickupDataRef,
      lineupDataRef,
      featureDataRef,
      storiesDataRef,
    };
  },
}).mount('#main');
